import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

import { arrowBackOutline } from "ionicons/icons";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'CommonHeader',
  props: {
  noBackButton: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {



const router = useRouter();

const back = () => {
  router.go(-1);
};

return (_ctx: any,_cache: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!

  return (_openBlock(), _createBlock(_component_ion_header, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_toolbar, null, {
        default: _withCtx(() => [
          (!__props.noBackButton)
            ? (_openBlock(), _createBlock(_component_ion_buttons, {
                key: 0,
                slot: "start"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, { onClick: back }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { icon: _unref(arrowBackOutline) }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_ion_title, null, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})